import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { projects } from '../data/projectsData';
import { FaArrowRight } from 'react-icons/fa';

const ProjectsContainer = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  color: #2c3e50;

  @media (max-width: 480px) {
    font-size: 1.8rem;
  }

  &:after {
    content: '';
    display: block;
    width: 60px;
    height: 4px;
    background: #007bff;
    margin: 1rem auto;
    border-radius: 2px;
  }
`;

const ProjectCard = styled.div`
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 2rem;
  margin-bottom: 3rem;
  padding: 1.5rem;
  border: 1px solid #eaeaea;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: white;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const Thumbnail = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  height: 200px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }
`;

const ProjectInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const ProjectTitle = styled.h3`
  font-size: 1.8rem;
  margin: 0;
  color: #2c3e50;
  font-weight: 600;

  @media (max-width: 480px) {
    font-size: 1.35rem;
  }
`;

const Technologies = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0.5rem 0;
`;

const TechTag = styled.span`
  background: #f0f4f8;
  color: #2c3e50;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
`;

const Description = styled.p`
  color: #666;
  line-height: 1.6;
  margin: 0;
`;

const ViewMoreButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.8rem 1.5rem;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 25px;
  width: fit-content;
  font-weight: 500;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #0056b3;
    transform: translateX(5px);
  }

  svg {
    transition: transform 0.3s ease;
  }

  &:hover svg {
    transform: translateX(3px);
  }
`;

function Projects() {
  return (
    <ProjectsContainer>
      <PageTitle>My Projects</PageTitle>
      {projects.map((project) => (
        <ProjectCard key={project.id}>
          <Thumbnail>
            <img src={project.thumbnail} alt={project.title} />
          </Thumbnail>
          <ProjectInfo>
            <ProjectTitle>{project.title}</ProjectTitle>
            <Technologies>
              {project.technologies.map((tech, index) => (
                <TechTag key={index}>{tech}</TechTag>
              ))}
            </Technologies>
            <Description>{project.description}</Description>
            <ViewMoreButton to={`/projects/${project.id}`}>
              View Details <FaArrowRight />
            </ViewMoreButton>
          </ProjectInfo>
        </ProjectCard>
      ))}
    </ProjectsContainer>
  );
}

export default Projects;
